import { EditKeyForm, KeyDialog, RemoveKeyDialog, useApi, useApiKey, } from 'app/domains/api-management';
export function ApiDialogs() {
    const { dialog, setDialog } = useApi();
    const apiKey = useApiKey(dialog === null || dialog === void 0 ? void 0 : dialog.id);
    if (!apiKey) {
        return null;
    }
    switch (dialog === null || dialog === void 0 ? void 0 : dialog.type) {
        case 'edit':
            return (<EditKeyForm initialValues={apiKey} id={dialog.id} onClose={() => setDialog(undefined)}/>);
        case 'delete':
            return <RemoveKeyDialog id={dialog.id} onClose={() => setDialog(undefined)}/>;
        case 'view':
            return <KeyDialog apiKey={apiKey} onClose={() => setDialog(undefined)}/>;
        default:
            return null;
    }
}
